import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const Registration = lazy(() => import("../../assets/js/react/components/registration/registration"));
const registrationElement = document?.getElementById('registration');
const descriptionElement = document?.getElementById('registration-description');
const title = registrationElement?.getAttribute('data-form-headline') || '';
const description = descriptionElement?.innerHTML || '';

CreateRoot('registration', <Registration title={title} description={description} />);
